import SearchPage from 'ui-component-library/components/GoogleCustomSearch/SearchPage'

const GOOGLE_SEARCH_API_KEY = process.env.GOOGLE_SEARCH_API_KEY

type Props = {
  searchTitleText: string
  submitButtonText: string
}

function SearchPageContainer(props: Props) {
  return GOOGLE_SEARCH_API_KEY ? (
    <SearchPage apiKey={GOOGLE_SEARCH_API_KEY} {...props} />
  ) : null
}

export default SearchPageContainer
